import { effects } from 'redux-saga'

import { discoverToken } from 'internal-components/src/redux/modules/paymentToken'

export default function* discoverTokens(action) {
  // eslint-disable-next-line no-restricted-syntax
  for (const signup of action.payload.signups) {
    if (signup.token) {
      yield effects.put.resolve(discoverToken(signup.token))
    }
  }
}



// WEBPACK FOOTER //
// ./src/redux/sagas/signupEdit/discoverTokens.js